export default __webpack_public_path__ + "static/media/106.2f6a05cb.jpg";